import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const FastMovingItemsPage = lazy(() => import('./pages/FastMovingItemsPage'));
const DepartmentMovementPage = lazy(() => import('./pages/DepartmentMovementPage'));

const fastMovingRoutes: RouteObject[] = [
  {
    path: 'fast-moving',
    element: <FastMovingItemsPage />,
  },
  {
    path: 'fast-moving/departments',
    element: <DepartmentMovementPage />,
  },
];

export default fastMovingRoutes;
